<template>
  <div class="w-100">

    <div class="row">
      <div class="col-12">
        <div class="headline d-flex flex-row align-items-center justify-content-between w-100 border-bottom pb-3">
          <h2 class="card-title font-weight-bolder">{{ $t('title.messages') }}</h2>
          <div>
            <b-button @click="openModal('send-email')" variant="success" class="mr-2">{{$t('filters.btn.send_email_message')}}</b-button>
            <b-button @click="openModal('send-sms')" variant="primary">{{$t('filters.btn.send_sms_message')}}</b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <div class="questions sygni-grid">
          <div class="">
            <div class="row filters">
              <div class="col-12">

                  <div class="row">
                    <div class="col-4">
                      <filter-select
                          :filter-query="filterQuery"
                          :options="selectOptions.type"
                          :multiple="false"
                          options-label="text"
                          options-track-by="value"
                          filter-name="type"
                          :label="$t('filters.label.message.type')"
                          :placeholder="$t('filters.placeholder.message_type')">
                      </filter-select>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="float-right">
                        <b-button @click="resetFilters()" variant="secondary mr-2">{{$t('filters.btn.clear')}}</b-button>
                        <b-button @click="applyFilters()" variant="primary">{{$t('filters.btn.apply')}}</b-button>
                      </div>
                    </div>
                  </div> <!-- #row-->

              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12">
                <grid-pagination :total-count="totalCount"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 @load-items="paginationReload"></grid-pagination>

                <div class="table-responsive">
                  <b-table striped show-empty
                           :empty-text="$t('table.no_results')"
                           :busy="isBusy"
                           hover
                           head-variant="dark"
                           outlined
                           :sort-by.sync="orderColumn"
                           :sort-desc.sync="orderDirection"
                           :no-local-sorting="true"
                           :items="items"
                           :fields="fields">

                    <template #cell(id)="data">
                      <div>
                        {{ data.item.id | shortId }}
                      </div>
                    </template>

                    <template #cell(firstMessageDate)="data">
                      <div>
                        {{ data.item.firstMessageDate | dateFormat }}
                      </div>
                    </template>

                    <template #cell(lastMessageDate)="data">
                      <div>
                        {{ data.item.lastMessageDate | dateFormat }}
                      </div>
                    </template>

                    <template #cell(status)="data">
                      <b-badge pill variant="success" v-if="data.value === 'open'">{{ $t(data.value) }}</b-badge>
                      <b-badge pill variant="danger" v-if="data.value === 'closed'">{{ $t(data.value) }}</b-badge>
                    </template>

                    <template #cell(actions)="data">
                      <div class="table-action--cell">
                        <b-button variant="primary" size="sm" @click="openModal('show-messages', data.item)">
                          {{ $t('table.btn.messages.show') }}
                        </b-button>
                      </div>
                    </template>

                  </b-table>

                </div> <!-- #table-responsive-->

                <grid-pagination :total-count="totalCount"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 @load-items="paginationReload"></grid-pagination>

              </div>
            </div>
          </div> <!-- #card-body-->
        </div> <!-- #card questions sygni-grid-->
      </div>
    </div>

    <div v-if="isBusy" class="spinner-wrapper">
      <b-spinner></b-spinner>
    </div>
  </div>

</template>

<script>

import GridMixin from "../../../components/grid/GridMixin";
import GridPagination from "../../../components/grid/grid-pagination/GridPagination";
import SendEmailModal from "./SendEmailModal";
import SendSmsModal from "./SendSmsModal";
import ShowModal from "./ShowModal";
import FilterSelect from "../../../components/grid/filters/FilterSelect";

export default {
  mixins: [GridMixin],
  components: {
    GridPagination,
    FilterSelect
  },
  data() {
    return {
      gridGetUrl: null,
      orderColumn: '',
      fields: [
        {key: 'id', label: this.$t('table.header.messages.id')},
        {key: 'topic', label: this.$t('table.header.messages.topic')},
        {key: 'type', label: this.$t('table.header.messages.medium')},
        {key: 'firstMessageDate', label: this.$t('table.header.messages.first_message_date')},
        {key: 'lastMessageDate', label: this.$t('table.header.messages.last_message_date')},
        {key: 'status', label: this.$t('table.header.messages.status')},
        {key: 'unreadCount', label: this.$t('table.header.messages.unread_count'), sortable: true},
        {key: 'actions', label: this.$t('table.header.actions')},
      ],
      items: [],
      selectOptions: {
        type: [
          {value: 'email', text: this.$t('option.message.email')},
          {value: 'sms', text: this.$t('option.message.sms')}
        ]
      },
    };
  },
  mounted() {
    this.getPlayerMessages();

    this.$on('refreshGrid', () => {
      this.getPlayerMessages();
    })
  },
  methods: {
    openModal(type, data) {
      switch (type) {
        case('send-email'): {
          this.$store.commit('modal/openModal', {
            parent: this,
            modal: SendEmailModal,
            modalName: 'send-email',
            props: {apiKey: this.apiKey}
          });
          break;
        }
        case('send-sms'): {
          this.$store.commit('modal/openModal', {
            parent: this,
            modal: SendSmsModal,
            modalName: 'send-sms',
            props: {apiKey: this.apiKey}
          });
          break;
        }
        case('show-messages'): {
          this.$store.commit('modal/openModal', {
            parent: this,
            modal: ShowModal,
            modalName: 'show-messages',
            props: {apiKey: this.apiKey, message: data}
          });
          break;
        }
        case('show-email'): {
          this.$store.commit('modal/openModal', {
            parent: this,
            modal: SendEmailModal,
            modalName: 'send-email',
            props: {apiKey: this.apiKey, message: data}
          });
          break;
        }
        case('show-sms'): {
          this.$store.commit('modal/openModal', {
            parent: this,
            modal: SendSmsModal,
            modalName: 'send-sms',
            props: {apiKey: this.apiKey, message: data}
          });
          break;
        }
      }
    },
    getPlayerMessages() {
      const userIdFromUrl = this.$route.params.id;
      this.gridGetUrl = `/api/inbox/message-to-player/${userIdFromUrl}`;
      this.loadItems();
    }
  },
  computed: {
    player: function () {
      return this.$store.getters["players/player"];
    },
    apiKey: function () {
      return this.$store.getters["root/apiKey"];
    }
  }
}
</script>
